import { RouteObject } from 'react-router-dom';
import projectsRoutes from '@app/modules/projects/ProjectsRoutes';
import App from '@app/App';
import PwcNavigate from '@app/shared/routing/PwcNavigate';
import NotFoundPage from '@app/shared/components/status-pages/NotFoundPage';
import NoAccessPage from '@app/shared/components/status-pages/NoAccessPage';
import ErrorPage from '@app/shared/components/status-pages/ErrorPage';
import { RootAppRoutes } from '@app/shared/enums/root-app-routes';
import { GlobalHistory } from '@app/shared/components/global-navigate/GlobalNavigate';
import RedirectPage from './shared/components/status-pages/RedirectPage';
import env from '@environment';
import UnderMaintenancePage from './modules/projects/maintenance/UnderMaintenancePage';
import adminRoutes from './modules/admin/AdminRoutes';
import { getFeatureFlag, FeatureFlags } from './core/feature-flags/feature-flags';
import { Logout } from './modules/Logout/Logout';

export interface RouteItem {
  route: string;
  title: string;
}
let projectRoutes: RouteObject[];
if (env.redirectUrl && env.redirectUrl.length > 0) {
  projectRoutes = [
    {
      path: '*',
      element: (
        <>
          <GlobalHistory />
          <App />
        </>
      ),
      children: [{ path: '*', element: <RedirectPage /> }],
    },
  ];
} else {
  const maintenanceRoute = !getFeatureFlag(FeatureFlags.BypassMaintenanceMode)
    ? [
        {
          path: RootAppRoutes.Maintenance,
          element: <UnderMaintenancePage />,
        },
      ]
    : [];

  projectRoutes = [
    {
      path: '/',
      element: (
        <>
          <GlobalHistory />
          <App />
        </>
      ),
      children: [
        {
          index: true,
          element: <PwcNavigate route="/projects" />,
        },
        {
          path: 'projects',
          children: [...projectsRoutes],
          handle: {
            crumb: { title: () => 'Projects' },
          },
        },
        {
          path: 'admin',
          children: [...adminRoutes],
          handle: {
            crumb: { title: () => 'Admin' },
          },
        },
        {
          path: RootAppRoutes.Logout,
          element: <Logout />,
        },
        {
          path: RootAppRoutes.Forbidden,
          element: <NoAccessPage />,
        },
        {
          path: RootAppRoutes.Error,
          element: <ErrorPage />,
        },
        {
          path: RootAppRoutes.NotFound,
          element: <NotFoundPage />,
        },
        {
          path: '*',
          element: <NotFoundPage />,
        },
        ...maintenanceRoute, // <-- Only add if not bypassing
      ],
    },
  ];
}

export const setAppRoutes = (): RouteObject[] => {
  return projectRoutes;
};
